export const Conditional = (props, { getState }) => {
  return {
    render: () => ({
      div: {
        className: props.className ?? '',
        children: () => {
          const condition =
            typeof props.condition === 'function' ? props.condition() : getState(props.condition);

          if (condition) {
            const content = props.then || props.children;
            return content ? [content].flat().filter(Boolean) : [];
          } else {
            const content = props.else;
            return content ? [content].flat().filter(Boolean) : [];
          }
        },
      },
    }),
  };
};
